import { useEffect, useState } from 'react';

import axios from 'axios';
import cloneDeep from 'lodash/cloneDeep';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { createContainer } from 'unstated-next';

import { DEFAULT_ADMIN_SETTINGS, SETTINGS_API } from '../../config/settingsConfig';
import { OrgSettings } from '../../types/adminConfig';
import { GetAdminSettings } from '../../types/apiTypes';
import { getUrls } from '../../utils/url';
import { PortalTabs } from './config/portalConfig';
import { transformSettingsData } from './utils/transformSettingsData';
import { useSchoolInfo } from '../../hooks/useSchoolInfo';

const useInitialAdminSettingsTab = () => {
    const location = useLocation();
    const defaultTab = Object.values(PortalTabs).find((tab) => location.pathname.includes(tab));

    const history = useHistory();
    const { path } = useRouteMatch();

    if (defaultTab) {
        return defaultTab;
    }

    history.push(`${path}${PortalTabs.Users}`);
    return PortalTabs.Users;
};

const useAdminSettings = () => {
    const DEFAULT_TAB = useInitialAdminSettingsTab();
    const [activeTab, setActiveTab] = useState<PortalTabs>(DEFAULT_TAB);
    const [adminSettings, setAdminSettings] = useState<OrgSettings>(cloneDeep(DEFAULT_ADMIN_SETTINGS.academic));
    const [organizationName, setOrganizationName] = useState<string>('');
    const [initialLoad, setInitialLoad] = useState<boolean>(true);

    console.log('activeTab', activeTab);

    const { loading: loadingSchool, data: school } = useSchoolInfo();

    const { api } = getUrls();

    useEffect(() => {
        const getSettings = async () => {
            try {
                const { data: body } = await axios.get<GetAdminSettings>(`${api}${SETTINGS_API}?dumpCache=1`);
                const { data, prefix } = body;

                setAdminSettings(transformSettingsData(data));

                if (prefix) {
                    setOrganizationName(prefix);
                }

                setInitialLoad(false);
            } catch (error) {
                // TODO: set error state and render error component?
            }
        };

        getSettings();
    }, [api]);

    return {
        activeTab,
        setActiveTab,
        school,
        loadingSchool,
        adminSettings,
        setAdminSettings,
        organizationName,
        initialLoad
    };
};

const AdminSettingsContainer = createContainer(useAdminSettings);

export default AdminSettingsContainer;
